import React, { useState } from "react";
import { useDispatch, connect } from "react-redux";
import { Button } from '../../ui/button';
import { COMMON_CONSTANTS, PASSWORD_CONSTANTS } from "../../sharedfiles/Constants";
import { setIntervalStopper } from "../AppSlice";

import { resetPassword } from "./PrimaryPlayerSlice";
import Tooltips from "../Common/Tooltip";
import { PLAYER_MODULE } from "../../sharedfiles/tooltipMsgs";
export const ResetPassword = (props) => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmpasscondition, setConfirmpasscondition] = useState(false);
  const [passwordCondition, setPasswordCondition] = useState(false);
  const [emptycondition, setEmptyCondition] = useState(false);
  const [validation, setValidation] = useState(false);
  const [success, setSuccess] = useState("");
  const passwordHandler = (e) => {
    setValidation(false);

    setPassword(e.target.value);
    // const pass = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{10,}$/;
    if (e.target.value === "") {
      setValidation(true);
    } else if (e.target.value !== "") {
      setValidation(false);
      setSuccess("success");
    }
  };
  const confirmPasswordHandler = (e) => {
    setConfirmPassword(e.target.value);
    e.target.value && setPasswordCondition(false);
  };

  const savePassword = () => {
    if (confirmPassword == "" && password !== "") {
      setConfirmpasscondition(true);
      setPasswordCondition(false);
      setEmptyCondition(false);
    } else if (confirmPassword != password) {
      setPasswordCondition(true);
      setEmptyCondition(false);
      setConfirmpasscondition(false);
    }

    if (password !== "" || confirmPassword !== "") {
      // if (confirmPassword != password) {
      //   setPasswordCondition(true);
      //   setEmptyCondition(false);

      // }
      if (confirmPassword == password && success === "success") {
        dispatch(resetPassword(props.userId, password));
        dispatch(setIntervalStopper(false));
        // props.setOpenResetDialog(false);
        setPassword("");
        setConfirmPassword("");
      }
      if (password !== validation) {
        setValidation(true);
      }
    }

    if (password == "" && confirmPassword == "") {
      setEmptyCondition(true);
      setPasswordCondition(false);
      setConfirmpasscondition(false);
    }
  };
  const onCancel = () => {
    setPassword("");
    setConfirmPassword("");
    setPasswordCondition(false);
    setConfirmpasscondition("");
    setValidation(false);
    setEmptyCondition(false);
    if (props.onCancel) {
      props.onCancel();
    }
  };
  return (
    <React.Fragment>
      <div className='rounded-lg border bg-card p-6'>
        <div className='space-y-6'>
          <div className='space-y-4'>
            <div className='flex items-center gap-2'>
              <label className='text-sm font-semibold text-foreground'>
                {PASSWORD_CONSTANTS.header_newPassword}
              </label>
              <Tooltips info={PLAYER_MODULE.newPassword} />
            </div>
            <div className='relative'>
              <input
                type='password'
                name='password'
                id='newpassword'
                value={password}
                maxLength='10'
                placeholder='Enter new password'
                className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary transition-colors ${
                  emptycondition ? 'border-red-500 focus:ring-red-500' : 'border-input'
                }`}
                onChange={passwordHandler}
              />
            </div>
            {emptycondition && (
              <p className='text-sm text-red-500 flex items-center gap-1'>
                <span>⚠</span>
                {PASSWORD_CONSTANTS.validPassword_ErrMsg}
              </p>
            )}
            {validation && !emptycondition && (
              <p className='text-sm text-amber-600 flex items-center gap-1'>
                <span>ℹ</span>
                Password must be at least 10 characters with uppercase, number, and special character
              </p>
            )}
          </div>

          <div className='space-y-4'>
            <div className='flex items-center gap-2'>
              <label className='text-sm font-semibold text-foreground'>
                {PASSWORD_CONSTANTS.header_confirmPassword}
              </label>
              <Tooltips info={PLAYER_MODULE.confirmPassword} />
            </div>
            <div className='relative'>
              <input
                type='password'
                name='confirmPassword'
                id='confirmPassword'
                maxLength='10'
                value={confirmPassword}
                placeholder='Confirm password'
                className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary transition-colors ${
                  passwordCondition || confirmpasscondition ? 'border-red-500 focus:ring-red-500' : 'border-input'
                }`}
                onChange={confirmPasswordHandler}
              />
            </div>
            {passwordCondition && (
              <p className='text-sm text-red-500 flex items-center gap-1'>
                <span>⚠</span>
                {PASSWORD_CONSTANTS.PasswordnotMatch_ErrMsg}
              </p>
            )}
            {confirmpasscondition && (
              <p className='text-sm text-red-500 flex items-center gap-1'>
                <span>⚠</span>
                {PASSWORD_CONSTANTS.confirmPassword_ErrMsg}
              </p>
            )}
          </div>
        </div>

        <div className='flex justify-end gap-3 pt-6 border-t mt-6'>
          <Button
            onClick={onCancel}
            id='cancelpassword'
            variant="outline"
            size="sm"
          >
            {COMMON_CONSTANTS.cancel}
          </Button>
          <Button
            onClick={savePassword}
            id='newpassSave'
            variant="default"
            size="sm"
          >
            {COMMON_CONSTANTS.save}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    userId: state.playersearch.userId,
  };
};
export default connect(mapStateToProps)(ResetPassword);
